import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { BarcodeScannerPage } from './barcode-scanner-page';
import { PagesModule } from 'pages/pages.module';
import { CsBarcodeDetectorDirective } from 'components/cs-barcode-detector/cs-barcode-detector.directive';

@NgModule({
    declarations: [BarcodeScannerPage],
    imports: [PagesModule, ComponentsModule, CsBarcodeDetectorDirective]
})
export class BarcodeScannerPageModule { }
